export const Clone = {
  json(clonable) {
    return JSON.parse(JSON.stringify(clonable, null, 2));
  }
};
